import { IAgency } from '../models/agency'
import { parse } from 'date-fns'

export const getTodaysOpeningHours = (openingHours: IAgency['openingHours']) => {
  const today = new Date().getDay()
  const currentHour = new Date().getHours()

  return openingHours.find(
    item =>
      item.dayNumber === today &&
      item.closed === false &&
      item.opening != null &&
      item.closing != null &&
      parse(item.opening, 'HH:mm', new Date()).getHours() <= currentHour &&
      parse(item.closing, 'HH:mm', new Date()).getHours() > currentHour
  )
}

export const renderOpeningHoursText = (
  openingHours?: IAgency['openingHours']
) => {
  if (!openingHours) {
    return 'Gesloten'
  }

  const todayOpeningHours = getTodaysOpeningHours(openingHours)

  if (!todayOpeningHours) {
    if (findNextOpeningHour(openingHours)) {
      return `Gesloten, opent ${findNextOpeningHour(
        openingHours
      )?.day.toLowerCase()} om ${findNextOpeningHour(openingHours)?.opening}`
    } else {
      return 'Gesloten'
    }
  }

  return `Geopend, sluit om ${todayOpeningHours.closing}`
}

export const findNextOpeningHour = (
  openingHours: IAgency['openingHours']
): IAgency['openingHours'][0] | undefined => {
  if (!openingHours) {
    return undefined
  }

  const todayOpeningHours = getTodaysOpeningHours(openingHours)
  const today = new Date().getDay()
  const currentHour = new Date().getHours()

  if (todayOpeningHours) {
    return todayOpeningHours
  }

  const nextOpeningHour = openingHours.find(
    item =>
      item.dayNumber === today &&
      item.opening != null &&
      item.closing != null &&
      item.closed === false &&
      parse(item.opening, 'HH:mm', new Date()).getHours() > currentHour
  )

  if (nextOpeningHour) {
    return nextOpeningHour
  }

  const nextOpeningDay = openingHours.find(item => item.dayNumber > today && item.closed === false)

  if (nextOpeningDay) {
    return nextOpeningDay
  }

  // If no later days in the week, return the first opening hour of the next week
  return openingHours.find(item => item.dayNumber < today && item.closed === false)
}

export const agencyOpenState = (
  openingHours?: IAgency['openingHours']
): 'closed' | 'open' | 'unknown' => {
  if (!openingHours) {
    return 'closed'
  }

  const today = new Date().getDay()
  const currentHour = new Date().getHours()

  const todayOpeningHours = openingHours.find(item => item.dayNumber === today && item.closed === false)

  if (!todayOpeningHours || !todayOpeningHours.opening || !todayOpeningHours.closing) {
    return 'unknown'
  }

  if (parse(todayOpeningHours.opening, 'HH:mm', new Date()).getHours() > currentHour || parse(todayOpeningHours.closing, 'HH:mm', new Date()).getHours() <= currentHour) {
    return 'closed'
  }

  return 'open'
}
